import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';

export class CustomDateRange {
  constructor(public fromDate: string, public toDate: string) {}
}

@Component({
  selector: 'custom-date-range-input',
  templateUrl: 'custom-date-range-input.component.html',
  styleUrls: ['custom-date-range-input.component.scss'],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDateRangeInputControl),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomDateRangeInputControl),
      multi: true,
    },
    {
      provide: MatFormFieldControl,
      useExisting: CustomDateRangeInputControl,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDateRangeInputControl
  implements MatFormFieldControl<CustomDateRange>
{
  ngControl: NgControl;
  stateChanges = new Subject<void>();
  errorState = false;
  placeholder: string;
  empty: boolean;
  shouldLabelFloat: boolean;
  autofilled?: boolean;

  public _placeholder: string;
  public focused: boolean;
  public _elementRef: ElementRef;
  public _disabled = false;
  public _required = false;
  public _value: CustomDateRange = new CustomDateRange('', '');
  public _valueFrom: string | null;
  public _valueTo: string | null;

  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);

    this.stateChanges.next();
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(dis) {
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }

  @Input()
  get value(): CustomDateRange | null {
    return this._value;
  }
  set value(dateFrom: CustomDateRange | null) {
    this._value = dateFrom;
    this.stateChanges.next();
  }

  @Input()
  get valueFrom(): string | null {
    return this._valueFrom;
  }
  set valueFrom(dateFrom: string | null) {
    this._valueFrom = dateFrom;
    this.stateChanges.next();
  }

  @Input()
  get valueTo(): string | null {
    return this._valueTo;
  }
  set valueTo(dateTo: string | null) {
    this._valueTo = dateTo;
    this.stateChanges.next();
  }

  @Input() typeFrom: string | null;
  @Input() typeTo: string | null;

  @Input('aria-describedby') userAriaDescribedBy: string = '';

  constructor(public elRef: ElementRef, public fm: FocusMonitor) {
    this._elementRef = elRef;
  }

  setDescribedByIds(ids: string[]): void {
    //const controlElement = this._elementRef.nativeElement.querySelector('.custom-date-range-input-container')!;
    //controlElement.setAttribute('aria-describedby', ids.join(' '));
  }

  onContainerClick(event: MouseEvent): void {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this._elementRef.nativeElement.querySelector('input').focus();
    }
  }

  static nextId = 0;
  @HostBinding() id = `custom-list-${CustomDateRangeInputControl.nextId++}`;

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  @Output() onDateChange: EventEmitter<{ type: string; selectedDate: any }> =
    new EventEmitter<{ type: string; selectedDate: any }>();

  dateChange(_type: string, _selectedDate: any) {
    this.onDateChange.emit({ type: _type, selectedDate: _selectedDate });
  }
}
